// log level
// 1 : [error]
// 2 : [error, warn]
// 3 : [error, warn, log]

const logLevel = _.toInteger(process.env.VUE_APP_LOG_LEVEL)
const dummyFunction = () => {}

const error = window.console.error
const warn = logLevel >= 2 ? window.console.warn : dummyFunction
const log = logLevel >= 3 ? window.console.log : dummyFunction

window.log = log
window.log.error = error
window.log.warn = warn
window.log.log = log
